import {Component, inject} from '@angular/core';
import {Router} from '@angular/router';
import {DeviceStore} from 'src/app/domain/devices/device.store';

@Component({
  selector: 'app-unassigned-tags-button',
  imports: [],
  templateUrl: './unassigned-tags-button.component.html',
  styleUrl: './unassigned-tags-button.component.css'
})
export class UnassignedTagsButtonComponent {

  deviceStore = inject(DeviceStore);

  private router = inject(Router);

  open(url: string): void {
    this.router.navigate([url]);
  }
}
